import styles from './SearchButton.module.css'
import classNames from 'classnames'
import { SearchIcon } from 'shared/icons'

interface SearchButtonProps {
    className?: string
    onClick?: (event: any) => void
}

export const SearchButton = (props: SearchButtonProps): JSX.Element => {
    const {
        className,
        onClick
    } = props

    const searchButtonClasses = classNames(styles.SearchButton, className)

    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={searchButtonClasses}
            onClick={handleButtonClick}>
            <span className={styles.SearchButton__IconContainer}>
                <SearchIcon/>
            </span>

            <span className={styles.SearchButton__Caption}>
                Search
            </span>
            
        </button>
    )
}